// URL search params for /files. Only well-formed values survive; anything else is
// dropped, never echoed. Every key is always returned (TanStack Router merges raw search under
// the validated object, so an omitted key would let an unvalidated value through).

// Guide slug: matches "start-here", "mfa-setup-2"; rejects "../x", "A b", "-x", "".
// https://regex101.com/?flavor=javascript&regex=%5E%5Ba-z0-9%5D%5Ba-z0-9-%5D%7B0%2C99%7D%24&testString=start-here%0Amfa-setup-2%0A..%2Fx%0AA%20b%0A-x
const SLUG = /^[a-z0-9][a-z0-9-]{0,99}$/;
const MAX_PAGE = 10_000;

export interface FilesSearch {
  readonly guide?: string | undefined;
  readonly page?: number | undefined;
}

export function pageParam(raw: unknown): number | undefined {
  const n = typeof raw === 'string' ? Number(raw) : raw;
  return typeof n === 'number' && Number.isInteger(n) && n >= 1 && n <= MAX_PAGE ? n : undefined;
}

export function validateFilesSearch(search: Record<string, unknown>): FilesSearch {
  const guide = search['guide'];
  return {
    guide: typeof guide === 'string' && SLUG.test(guide) ? guide : undefined,
    page: pageParam(search['page']),
  };
}
